// サブディレクトリ独自対応
function getAccessSuffix() {
  return "_access";
}

export function setAccessCookie(subDirName, days) {
  const value = "true";
  const subDirWithAccess = subDirName + getAccessSuffix();
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + days);
  
  const expires = "; expires=" + expirationDate.toUTCString();
  document.cookie = subDirWithAccess + "=" + value + expires + "; path=/";
}

export function getAccessCookie(name) {
  const subDirWithAccess = name + getAccessSuffix();
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${subDirWithAccess}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}